import { render, staticRenderFns } from "./ClassExamAnswer.vue?vue&type=template&id=9409d4ce&scoped=true&"
import script from "./classexamanswer.js?vue&type=script&lang=js&"
export * from "./classexamanswer.js?vue&type=script&lang=js&"
import style0 from "./ClassExamAnswer.vue?vue&type=style&index=0&id=9409d4ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9409d4ce",
  null
  
)

export default component.exports